import type { ReactNode } from 'react';
import { lazy } from 'react';
const TrophyIcon = lazy(() => import('../../../../../components/SVGIcons/TrophyIcon'));

import classNames from 'classnames';

import styles from './TournamentWideWidget.module.scss';

interface TournamentWideWidgetProps {
  positionValue: string | null;
  widgetImageUrl?: string;
  timer?: ReactNode;
}

export function TournamentWideWidget(props: TournamentWideWidgetProps) {
  const { widgetImageUrl, positionValue, timer } = props;
  const noPosition = !positionValue;

  return (
    <div className={styles.container}>
      {widgetImageUrl ? (
        <img alt="" className={styles.img} src={widgetImageUrl} />
      ) : (
        <TrophyIcon className={styles.img} />
      )}

      <div className={styles.content}>
        {noPosition ? null : (
          <div className={styles.positionContainer}>
            <span className={styles.counterText}>{positionValue}</span>
          </div>
        )}
        <div className={classNames(styles.timer, noPosition && styles.noPositionTimer)}>{timer}</div>
      </div>
    </div>
  );
}
